import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';

/**
 * Página de configuración para Coordinador.
 * Muestra tarjetas (estilo dashboard) para acceder a cada sección de configuración.
 */
const CONFIG_ITEMS = [
  { path: '/dashboard/configuracion/plantillas-mail', icon: '📧', label: 'Plantillas mail' },
  { path: '/dashboard/configuracion/lista-negra', icon: '🚫', label: 'Lista Negra' },
  { path: '/dashboard/configuracion/bloquear-registro', icon: '🔒', label: 'Bloquear registro' },
];

const Configuracion = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="dashboard-header">
        <h1>Configuración</h1>
        <p>Opciones de configuración del campus.</p>
      </div>
      <section className="dashboard-section">
        <h2 className="dashboard-section-title">Secciones</h2>
        <div className="dashboard-grid">
          {CONFIG_ITEMS.map((item) => (
            <button
              key={item.path}
              type="button"
              className="dashboard-card"
              onClick={() => navigate(item.path)}
            >
              <div className="dashboard-card-icon">{item.icon}</div>
              <h3>{item.label}</h3>
            </button>
          ))}
        </div>
      </section>
    </>
  );
};

export default Configuracion;
